import { getIsVSBPortal } from 'pricing-pages-lib/utils/companyDetailsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { FetchCompanyDetailsRequestTypes } from '../actions/CompanyDetailsActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { transformState } from './SelectorUtils';
export const companyDetailsSelector = state => {
  return state.companyDetails;
};
export const fetchCompanyDetailsStatus = makeRequestStatusSelector(FetchCompanyDetailsRequestTypes.REQUEST);
export const getIsVSBPortalSelector = createSelectorFromUtil(getIsVSBPortal, transformState);